import { default as _91clientId_93pJZpejaPILMeta } from "/vercel/path0/pages/clients/[clientId].vue?macro=true";
import { default as _91documentId_933d2ZMss72kMeta } from "/vercel/path0/pages/documents/[documentId].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as index011ZebFjcDMeta } from "/vercel/path0/pages/orgs/[orgId]/index.vue?macro=true";
import { default as profiles10q2Dj4h2oMeta } from "/vercel/path0/pages/orgs/[orgId]/profiles.vue?macro=true";
import { default as _91profileId_93RjtU3VL2vXMeta } from "/vercel/path0/pages/profiles/[profileId].vue?macro=true";
import { default as _91resumeId_93e0dFtMvjCtMeta } from "/vercel/path0/pages/resumes/[resumeId].vue?macro=true";
import { default as _91searchId_93Tb6cKAaelTMeta } from "/vercel/path0/pages/searches/[searchId].vue?macro=true";
export default [
  {
    name: "clients-clientId",
    path: "/clients/:clientId()",
    component: () => import("/vercel/path0/pages/clients/[clientId].vue").then(m => m.default || m)
  },
  {
    name: "documents-documentId",
    path: "/documents/:documentId()",
    component: () => import("/vercel/path0/pages/documents/[documentId].vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "orgs-orgId",
    path: "/orgs/:orgId()",
    component: () => import("/vercel/path0/pages/orgs/[orgId]/index.vue").then(m => m.default || m)
  },
  {
    name: "orgs-orgId-profiles",
    path: "/orgs/:orgId()/profiles",
    component: () => import("/vercel/path0/pages/orgs/[orgId]/profiles.vue").then(m => m.default || m)
  },
  {
    name: "profiles-profileId",
    path: "/profiles/:profileId()",
    component: () => import("/vercel/path0/pages/profiles/[profileId].vue").then(m => m.default || m)
  },
  {
    name: "resumes-resumeId",
    path: "/resumes/:resumeId()",
    component: () => import("/vercel/path0/pages/resumes/[resumeId].vue").then(m => m.default || m)
  },
  {
    name: "searches-searchId",
    path: "/searches/:searchId()",
    component: () => import("/vercel/path0/pages/searches/[searchId].vue").then(m => m.default || m)
  }
]